<template>
  <div>
    <printer-order-log v-show="printeractive" ref="printerOrderLog" :sumOfOrders="sumOfOrders" :sumOfExpenses="sumOfExpenses" :getTotalPrice="getTotalPrice"
      :getTotalExpensePrice="getTotalExpensePrice" :reportDate="reportDate" />
    <vs-popup :active.sync="isActive" id="totalOrderLogsPopup" :title="reportTimeRange">
      <vs-row vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12">
          <vs-table ref="table" :data="sumOfOrders" class="w-full">

            <template slot="thead">

              <vs-th>
                <p>Ödeneme Seçeneği</p>
              </vs-th>
              <vs-th>
                <p>Adet</p>
              </vs-th>
              <vs-th>
                <p>Tutar</p>
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                  :class="{'row-bg-danger' : tr.effect == 'Negatif', 'row-bg-warning' : tr.effect == 'Nötr'}">

                  <vs-td>
                    <p class="font-medium truncate">{{ tr.paymentName }}</p>
                  </vs-td>

                  <vs-td>
                    <p class="font-medium truncate">{{ tr.totalCount }}</p>
                  </vs-td>

                  <vs-td>
                    <p class="font-medium truncate">{{ $toCurrency(tr.totalPrice) }}</p>
                  </vs-td>


                </vs-tr>
                <vs-tr v-if="sumOfExpenses.length > 0" class="row-bg-danger">
                  <vs-td>
                    <p class="font-medium truncate">Gider</p>
                  </vs-td>
                  <vs-td>
                    <p class="font-medium truncate">{{sumOfExpenses.length}}</p>
                  </vs-td>
                  <vs-td>
                    <p class="font-medium truncate">{{$toCurrency(getTotalExpensePrice)}}</p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-2">
          <vs-col vs-type="block" vs-w="6" vs-justify="flex-start">
            <vs-button @click="printOrderLogs" color="primary" icon-pack="feather" icon="icon-printer">
              Yazdır
            </vs-button>
          </vs-col>
          <vs-col vs-type="block" vs-w="6" vs-justify="flex-end">
            <div class="flex justify-flex-end">
              <span class="h5">Toplam Net Ciro :</span>
              <span class="h4 text-primary bold ml-3">{{$toCurrency(getTotalPrice)}}</span>
            </div>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
  import PrinterOrderLog from "../OrderLog/TotalOrderLogs/Printer";
  import {
    getSumOfOrdersLive
  } from "@/api/Reports";
  export default {
    data() {
      return {
        isActive: false,
        printeractive: false,
        sumOfOrders: [],
        reportTimeRange:null,
        sumOfExpenses: [],
        filterOptions: {
          endDate: new Date(Date.now()),
          startDate: new Date(Date.now()),
          branchId: "",
          startTime: "00:00",
          endTime: "23:59"
        },
      }
    },
    components: {
      PrinterOrderLog
    },
    watch: {
      isActive(val) {
        if (val) this.saveFilterOptions();
      }
    },
    computed: {
      reportDate(){
       return this.filterOptions.startDate.toString();
      },
      getTotalExpensePrice() {
        return this.sumOfExpenses.reduce(function (total, num) {
          return total + num.price;
        }, 0);
      },
      getTotalPrice() {

        return this.sumOfOrders.reduce(function (total, num) {
          return total + (num.effect == 'Pozitif' ? num.totalPrice : 0);
        }, 0);
      },
    },
    methods: {
      printOrderLogs() {
        this.printeractive = true;
        this.$nextTick(() => {
  this.$refs.printerOrderLog.printTotalOrderLogs();
});
      },
      saveFilterOptions() {
        getSumOfOrdersLive().then(res => {
          if (res && res.status == 200) {
            this.sumOfOrders = res.data.paymentReport;
            this.sumOfExpenses = res.data.sumOfExpenses;
            this.reportTimeRange = res.data.timeRange;
          } else {
            this.$fire({
              title: "Hata : " + res.status,
              text: "Rapor Hazırlanamadı !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Rapor Hazırlanamadı !"
            });
          }
        }).catch(() => {
          this.$fire({
            title: "Hata !",
              text: "Rapor Hazırlanamadı !",
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
    }
  }

</script>

<style>
  .row-bg-danger {
    background-color: rgba(238, 66, 75, 0.5) !important;
  }

  .row-bg-warning {
    background-color: rgba(255, 159, 67, .5) !important;
  }
  .swal2-container {
  z-index: 99999;
}
</style>
